import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { useApiContext } from '../context/ApiContext';

function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const { session } = useAppContext();
  const { api } = useApiContext();

  useEffect(() => {
    async function verifySubscription() {
      if (!session?.user) return;
      
      setLoading(true);
      
      try {
        // URL의 query string에서 session_id를 가져옴
        const queryParams = new URLSearchParams(location.search);
        const sessionId = queryParams.get('session_id');
        if (!sessionId) {
          console.error('세션 ID가 없습니다');
          return;
        }

        // API를 통해 구독 확인
        const { data, error } = await api.verifySubscription(sessionId);

        if (error) {
          throw new Error('구독 확인 실패: ' + error.message);
        }

        setSubscriptionStatus(data.subscription);
      } catch (err) {
        console.error('구독 확인 중 오류 발생:', err);
      } finally {
        setLoading(false);
      }
    }

    verifySubscription();
  }, [location.search, session, api]);

  // 사용자가 미로그인 상태라면 돌아가기
  if (!session?.user) {
    navigate('/');
    return null;
  }

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto py-12 px-4 text-center">
        <p className="text-xl">구독 정보를 확인 중입니다...</p>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center">
        <h2 className="text-3xl font-bold text-green-600 mb-4">결제가 완료되었습니다!</h2>
        <p className="text-xl text-gray-700 mb-6">
          구독이 성공적으로 활성화되었습니다.
        </p>

        {subscriptionStatus && (
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <p className="font-medium">구독 정보</p>
            <p>플랜: {subscriptionStatus.plan_name}</p>
            <p>상태: {subscriptionStatus.status === 'active' ? '활성' : '비활성'}</p>
          </div>
        )}

        <button 
          onClick={() => navigate('/my')}
          className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700"
        >
          내 계정으로 이동
        </button>
      </div>
    </div>
  );
}

export default Success;
